import { TemplateHelperInfo } from "@helios/toolbox-types";
import { createContext, PropsWithChildren, useContext } from "react";
import { useUserInfo } from "./user-info";

const TemplateHelperInfoContext = createContext<
  | { templateHelperInfo: TemplateHelperInfo; refetchHelperInfo: () => void; editEnabled: boolean }
  | undefined
>(undefined);

export function TemplateHelperInfoProvider({
  children,
  templateHelperInfo,
  refetchHelperInfo,
}: PropsWithChildren<{}> & { templateHelperInfo: TemplateHelperInfo; refetchHelperInfo: () => void }) {
  const [userInfo] = useUserInfo();
  return (
    <TemplateHelperInfoContext.Provider
      value={{ templateHelperInfo, refetchHelperInfo, editEnabled: userInfo?.rights.template_helper || false }}
    >
      {children}
    </TemplateHelperInfoContext.Provider>
  );
}

export function useTemplateHelperInfo() {
  const templateHelperInfo = useContext(TemplateHelperInfoContext);
  if (templateHelperInfo === undefined) {
    throw new Error("useTemplateHelperInfo must be used within a TemplateHelperInfoContext");
  }
  return templateHelperInfo;
}
